/** Browser-memory-only demonstration. No dates, customers, network or storage. */
export const SERVICES = Object.freeze(['Consultation', 'Planning session', 'Project review']);
export const DAYS = Object.freeze(['Day 1', 'Day 2', 'Day 3']);
export const TIMES = Object.freeze(['09:00', '11:00', '14:00']);
export const STATUSES = Object.freeze(['Pending', 'Confirmed', 'Completed']);

export function initialBookings() { return { nextId: 1, bookings: [] }; }
export function isAvailable(state, day, time) {
  return DAYS.includes(day) && TIMES.includes(time) && !state.bookings.some(b => b.day === day && b.time === time);
}
export function createBooking(state, selection) {
  const { service, day, time } = selection;
  if (!SERVICES.includes(service) || !isAvailable(state, day, time)) return { state, booking: null };
  const booking = { id: `DEMO-${String(state.nextId).padStart(3, '0')}`, service, day, time, guest: 'Sample guest', status: 'Pending' };
  return { state: { nextId: state.nextId + 1, bookings: [...state.bookings, booking] }, booking };
}
export function advanceBooking(state, id) {
  const row = state.bookings.find(b => b.id === id);
  const next = row && STATUSES[STATUSES.indexOf(row.status) + 1];
  if (!next) return state;
  return { ...state, bookings: state.bookings.map(b => b.id === id ? { ...b, status: next } : b) };
}
export function bookingCounts(state) {
  return Object.fromEntries(STATUSES.map(status => [status, state.bookings.filter(b => b.status === status).length]));
}
export function filteredBookings(state, filter = 'All') {
  return state.bookings.filter(b => filter === 'All' || b.status === filter);
}

/** Explicit opt-in fixtures, never merged over a customer's current demo records. */
export function loadSampleBookings(state) {
  if (state.bookings.length) return state;
  let sample = initialBookings();
  SERVICES.forEach((service, index) => {
    sample = createBooking(sample, { service, day: DAYS[index], time: TIMES[index] }).state;
  });
  sample = advanceBooking(sample, 'DEMO-002');
  sample = advanceBooking(advanceBooking(sample, 'DEMO-003'), 'DEMO-003');
  return sample;
}

export function visibleBookingSelection(state, filter, selectedId) {
  const rows = filteredBookings(state, filter);
  return rows.find(row => row.id === selectedId) || rows[0] || null;
}
